import deDE from './de-DE.json';
import daDK from './da-DK.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import itIT from './it-IT.json';
import nbNO from './nb-NO.json';
import nlNL from './nl-NL.json';
import svSE from './sv-SE.json';

export const translationResources = {
  'de-DE': deDE,
  'da-DK': daDK,
  'en-US': enUS,
  'es-ES': esES,
  'fr-FR': frFR,
  'it-IT': itIT,
  'nb-NO': nbNO,
  'nl-NL': nlNL,
  'sv-SE': svSE
};
